import get from 'lodash/get';
import { BooleanField, DateField, NumberField, ShowButton, ShowContextProvider, ShowView, Tab, TabbedShowLayout, TextField, useRecordContext, useShowController } from 'react-admin';
import { JsonField } from 'react-admin-json-view';
import ContextTitle from '../../Components/ContextTitle';
import { useReactJsonTheme } from '../../Components/Layout/jsonViewTheme';
import { LoginAsButton } from '../../Components/LoginAsButton';
import { RecalculateButton } from './RecalculateButton';

const ProfileShow = () => {
  const controllerProps = useShowController();
  const jsonTheme = useReactJsonTheme();
  const record = useRecordContext(controllerProps);
  const company = get(record, 'company');
  const companyName = get(company, 'name');
  return (
    <ShowContextProvider value={controllerProps}>
      <ShowView title={<ContextTitle context="name" />}>
        <TabbedShowLayout>
          <Tab label="Summary">
            <TextField source="id" />
            <TextField source="uuid" />
            <TextField source="fullName" />
            <TextField source="matricula" />
            <TextField source="pis" />
            <TextField source="role" />
            <TextField source="jobDescription" />
            <TextField source="employeeStatus" />
            <TextField source="avatarId" />
            <NumberField source="avatarVersion" />
            <NumberField source="teamId" />
            <NumberField source="departmentId" />
            <NumberField source="subsidiaryId" />
            <TextField source="defaultTimeZone" />
            <ShowButton resource="companies" record={company} label={companyName} />
            <LoginAsButton fullNameSource="user.fullName" />
            <RecalculateButton />
          </Tab>
          <Tab label="Changes">
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
            <DateField source="employeeStatusChangedAt" />
            <DateField source="migratedAt" />
            <DateField source="punchesLastUpdatedAt" />
            <DateField source="manualPunchesLastUpdatedAt" />
            <DateField source="syncedAt" />
            <DateField source="deletedAt" />
            <DateField source="requestsLastUpdatedAt" />
            <TextField source="resetPasswordToken" />
            <DateField source="resetPasswordSentAt" />
            <DateField source="rememberCreatedAt" />
          </Tab>
          <Tab label="SingnIn Info">
            <TextField source="invitationToken" />
            <NumberField source="signInCount" />
            <DateField source="currentSignInAt" />
            <DateField source="lastSignInAt" />
            <TextField source="currentSignInIp" />
            <TextField source="lastSignInIp" />
          </Tab>
          <Tab label="Integrations">
            <TextField source="sourcePlatform" />
            <TextField source="sourceType" />
            <TextField source="externalSource" />
            <TextField source="externalId" />
          </Tab>
          <Tab label="Miscellaneous">
            <NumberField source="faceModelId" />
            <DateField source="lastActionAt" />
            <TextField source="referralCode" />
            <DateField source="lastLockDate" />
            <TextField source="lastLockBy" />
            <TextField source="importBatchUuid" />
            <TextField source="faceTemplate" />
            <TextField source="faceId" />
            <NumberField source="faceVersion" />
            <DateField source="inboxUpdatedAt" />
            <DateField source="startDate" />
            <TextField source="locale" />
            <DateField source="deactivateDate" />
            <BooleanField source="hasTerminatedPayrollGroup" />
            <JsonField source="metadata" jsonString={false} reactJsonOptions={{ theme: jsonTheme }} />
            <TextField source="projectEmployeeCost" />
          </Tab>
        </TabbedShowLayout>
      </ShowView>
    </ShowContextProvider>
  );
};

export default ProfileShow;
